<template>
  <div class="about">
    <div class="flex align-item-center">
      <div class="img_box">
        <img class="about_img" src="../../assets/img/about_img.png" alt="">
      </div>
      <div class="content_box">
        <div class="about_title">
          关于我们
          <div class="title_line flex justify-content-between">
            <div class="line"></div>
          </div>
        </div>
        <div class="about_content">
          微星网络将创新思维，智能技术和深厚的行业经验与来自生态系统合作伙伴的领先技术加以融合，致力于帮助企业实现业务重塑，数字化转型和规模化创新。
        </div>
        <div class="about_content">
          借助SAP ，Oracle ，Microsoft 等智能平台实现企业智能化发展和规模化创新。
        </div>
        <div class="about_content">
          通过智能软件工程服务，运用数据，人工智能和定制系统将技术创新成果转化为竞争优势。应用智能云和基础架构服务推动创新并加速增长。
        </div>
        <div class="about_content">
          借助规模化技术创新提升企业绩效，领先未来。
        </div>
      </div>
    </div>

    <div class="about_item_box flex justify-content-between">
      <div class="about_item flex">
        <div class="item_img">
          <img class="item_img" src="../../assets/img/about_img1.png" alt="">
        </div>
        <div class="flex1">
          <div class="item_title">初衷与理想</div>
          <div class="item_info">本着“相信科技，追求极致”的初衷与理想，微星网络科技于2015年在北京中关村科技园成立，目前公司总部设在上海。经过五年的耕耘与成长，微星网络科技逐渐崭露头角，各项业务发展迅猛，现已成为国内证券大数据的领头羊</div>
        </div>
      </div>
      <div class="about_item flex">
        <div class="item_img">
          <img class="item_img" src="../../assets/img/about_img2.png" alt="">
        </div>
        <div class="flex1">
          <div class="item_title">我们的产品</div>
          <div class="item_info">依托公司自建的国际领先的大数据平台，微星网络科技相继开发上线了面向企业招聘的易招聘SaaS软件；面向股民的超短线炒股神器——快涨APP，智能舆情系统和智能投顾管理系统；以及面向机构用户的FOF和PE管理系统；面向律师行业的Kindlelaw智能SaaS软件；</div>
        </div>
      </div>
      <div class="about_item flex">
        <div class="item_img">
          <img class="item_img" src="../../assets/img/about_img3.png" alt="">
        </div>
        <div class="flex1">
          <div class="item_title">我们的优势</div>
          <div class="item_info">微星网络将创新思维，智能技术和深厚的行业经验与来自生态系统合作伙伴的领先技术加以融合，致力于帮助企业实现业务重塑，数字化转型和规模化创新。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      
    };
  },
  mounted: function() {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {
    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/about.vue